import bootstrap from "./bootstrap5.3.2.bundle.js";

document.addEventListener("DOMContentLoaded", function () {
  const activationForms = document.querySelectorAll(".activation-form");

  if (activationForms.length) {
    armActivationForms();
  }

  //Check if element with id signin-form exists
  if (document.getElementById("signin-form") !== null) {
    armLoginForm();
  }

  if (document.querySelector("table.today-laundry-bookings")) {
    armButtonAutoReload();
  }

  if (document.querySelector(".wallbox-svg-container")) {
    armWallboxIndicators();
  }

  if (document.getElementById("wallbox-session-app")) {
    armWallboxSession();
  }
});

function armLoginForm() {
  document.getElementById("signin-form").addEventListener("submit", (event) => {
    console.log("submit");
    if (!document.querySelector('input[name="tos"]').checked) {
      event.preventDefault();
      alert("Sie müssen die Nutzungsbedingungen akzeptieren.");
    }
  });
}

const WALLBOX_STATUS_MAP = {
  0: "pending",
  1: "charging",
  2: "finished",
  3: "failed",
  4: "timeout",
};

const WALLBOX_PENDING_TIMEOUT_SECONDS = 65;

function armWallboxSession() {
  const app = document.getElementById("wallbox-session-app");
  const data = app.dataset;

  let initialStatus = WALLBOX_STATUS_MAP[parseInt(data.status)] || "unknown";

  let state = {
    status: initialStatus,
    energy: parseFloat(data.energy),
    power: 0,
    createdAt: parseInt(data.createdAt),
    durationSeconds: parseInt(data.durationSeconds || 0),
    finishedAt: data.finishedAt,
    pricePerKwh: parseFloat(data.pricePerKwh || 0),
    pollInterval: null,
    uiInterval: null,
    elements: {
      states: {
        pending: document.getElementById("state-pending"),
        charging: document.getElementById("state-charging"),
        finished: document.getElementById("state-finished"),
        failed: document.getElementById("state-failed"),
      },
      retryTimer: document.getElementById("retry-timer"),
      retryBtn: document.getElementById("retry-btn"),
      displayEnergy: document.getElementById("display-energy"),
      displayPower: document.getElementById("display-power"),
      displayDuration: document.getElementById("display-duration"),
      displayCost: document.getElementById("display-cost"),
      finishedEnergy: document.getElementById("finished-energy"),
      finishedTime: document.getElementById("finished-time"),
      finishedCost: document.getElementById("finished-cost"),
      finishedDuration: document.getElementById("finished-duration"),
    },
  };

  updateWallboxUI(state);

  if (state.status === "pending" || state.status === "charging") {
    startWallboxLoops(state);
  }

  // Setup Retry Forms
  const retryForm = document.getElementById("retry-form");
  if (retryForm) retryForm.action = data.startUrl;

  const failedRetryForm = document.getElementById("failed-retry-form");
  if (failedRetryForm) failedRetryForm.action = data.startUrl;
}

function startWallboxLoops(state) {
  state.pollInterval = setInterval(() => fetchWallboxStatus(state), 2000);
  state.uiInterval = setInterval(() => {
    if (state.status === "pending" || state.status === "charging") {
      updateWallboxUI(state);
    }
  }, 1000);
}

function fetchWallboxStatus(state) {
  const app = document.getElementById("wallbox-session-app");

  fetch(app.dataset.statusUrl)
    .then((response) => response.json())
    .then((data) => {
      state.status = WALLBOX_STATUS_MAP[data.status] || "unknown";
      if (data.energy !== undefined) state.energy = data.energy;
      if (data.power !== undefined) state.power = data.power;
      if (data.finished_at !== undefined) state.finishedAt = data.finished_at;
      if (data.duration_seconds !== undefined)
        state.durationSeconds = data.duration_seconds;
      if (data.cost !== undefined) state.costFormatted = data.cost;
      if (data.duration !== undefined) state.durationFormatted = data.duration;

      if (state.status !== "pending") {
        updateWallboxUI(state);
      }

      if (["finished", "failed", "timeout"].includes(state.status)) {
        clearInterval(state.pollInterval);
        clearInterval(state.uiInterval);
      }
    })
    .catch((error) => console.error("Error polling status:", error));
}

function updateWallboxUI(state) {
  // Update States Visibility
  Object.keys(state.elements.states).forEach((s) => {
    const el = state.elements.states[s];
    if (el) {
      let match = s === state.status;
      if (state.status === "timeout" && s === "failed") match = true;
      el.classList.toggle("d-none", !match);
    }
  });

  if (state.status === "pending") {
    // Calculate remaining
    const now = Math.floor(Date.now() / 1000);
    const remaining = Math.max(
      0,
      WALLBOX_PENDING_TIMEOUT_SECONDS - (now - state.createdAt)
    );

    if (state.elements.retryTimer) {
      state.elements.retryTimer.textContent = remaining;
    }

    if (state.elements.retryBtn) {
      state.elements.retryBtn.disabled = remaining > 0;
    }

    if (remaining <= 0) {
      state.status = "timeout";
      updateWallboxUI(state);
    }
  } else if (state.status === "charging") {
    if (state.elements.displayEnergy)
      state.elements.displayEnergy.textContent = (state.energy / 1000).toFixed(
        2
      );
    if (state.elements.displayPower)
      state.elements.displayPower.textContent = (state.power / 1000).toFixed(
        1
      );

    if (state.elements.displayDuration) {
      const hours = Math.floor(state.durationSeconds / 3600);
      const minutes = Math.floor((state.durationSeconds % 3600) / 60);
      const seconds = state.durationSeconds % 60;
      state.elements.displayDuration.textContent = `${hours}:${minutes
        .toString()
        .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

      state.durationSeconds++;
    }

    if (state.elements.displayCost) {
      const cost = (state.energy / 1000) * state.pricePerKwh;
      state.elements.displayCost.textContent = cost
        .toFixed(2)
        .replace(".", ",");
    }
  } else if (state.status === "finished") {
    if (state.elements.finishedEnergy)
      state.elements.finishedEnergy.textContent = (state.energy / 1000).toFixed(
        2
      );
    if (state.elements.finishedTime)
      state.elements.finishedTime.textContent = state.finishedAt;
    if (state.elements.finishedCost && state.costFormatted)
      state.elements.finishedCost.textContent = state.costFormatted;
    if (state.elements.finishedDuration && state.durationFormatted)
      state.elements.finishedDuration.textContent = state.durationFormatted;
  }
}

let activationDelayTimer;

function activationDelayHandler(modal, submitButton) {
  let delay = parseInt(modal._element.dataset.readDelay);
  if (delay > 0) {
    submitButton.textContent = `Bitte Hinweise lesen... (${delay})`;
    submitButton.disabled = true;
    delay--;
    modal._element.dataset.readDelay = delay;
    return;
  }

  submitButton.textContent = submitButton.dataset.originalText;
  submitButton.disabled = false;
  window.clearInterval(activationDelayTimer);
}

function armActivationForms() {
  let currentForm; // To keep track of the current form being processed
  let confirmationModalElement = document.getElementById("activation-modal");
  let confirmSubmitButtons =
    confirmationModalElement.querySelectorAll(".activation-submit"); // Select all submit buttons
  let confirmationModal = new bootstrap.Modal(confirmationModalElement);

  // Check if the modal has data-read-delay > 0. If so, we disable the submit button and enable it after the delay
  if (confirmationModalElement.dataset.readDelay > 0) {
    let submitButton = confirmationModalElement.querySelector(
      ".activation-submit.first-activation"
    );
    //Save the original text of the submit button to its data attribute
    submitButton.dataset.originalText = submitButton.textContent;
    submitButton.dataset.originalDelay =
      confirmationModalElement.dataset.readDelay;

    //Start the timer when the modal is shown
    confirmationModalElement.addEventListener("show.bs.modal", function () {
      activationDelayHandler(confirmationModal, submitButton);
      activationDelayTimer = window.setInterval(() => {
        activationDelayHandler(confirmationModal, submitButton);
      }, 1000);
    });

    //Clear the timer when the modal is hidden
    confirmationModalElement.addEventListener("hidden.bs.modal", function () {
      window.clearInterval(activationDelayTimer);
      confirmationModalElement.dataset.readDelay =
        submitButton.dataset.originalDelay;
    });
  }

  document.querySelectorAll(".activation-form").forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault(); // Prevent form from submitting immediately
      currentForm = form; // Store the current form

      //Check if form.dataset.price is set and is > 0
      const paid = form.dataset.price && form.dataset.price > 0;

      if (paid) {
        confirmationModalElement
          .querySelectorAll(".activation-price")
          .forEach(function (span) {
            span.textContent = new Intl.NumberFormat("de-DE", {
              style: "currency",
              currency: "EUR",
            }).format(form.dataset.price);
          });
      }

      //Hide all elements with class paid
      confirmationModalElement
        .querySelectorAll(".paid")
        .forEach(function (element) {
          element.style.display = paid ? "inline" : "none";
        });

      //In the confirmation modal hide all elements with class activation-dynamic
      confirmationModalElement
        .querySelectorAll(".activation-dynamic")
        .forEach(function (element) {
          element.style.display = "none";
        });

      //If, in the forms dataset reactivation is set to true, show the reactivation elements
      if (form.dataset.reactivation === "1") {
        confirmationModalElement
          .querySelectorAll(".reactivation")
          .forEach(function (element) {
            element.style.display = "block";
          });
      } else {
        //If not, show the first activation elements
        confirmationModalElement
          .querySelectorAll(".first-activation")
          .forEach(function (element) {
            element.style.display = "block";
          });
      }

      confirmationModal.show(); // Show the confirmation modal
    });
  });

  // Attach click event listener to all confirmation buttons
  confirmSubmitButtons.forEach(function (button) {
    button.addEventListener("click", function () {
      if (currentForm) {
        currentForm.submit();
      }
    });
  });
}

function armButtonAutoReload() {
  if (
    document.querySelector("table.today-laundry-bookings").dataset
      .buttonRefresh != "1"
  ) {
    return;
  }
  setInterval(fetchButtonStates, 10000);
}

function fetchButtonStates() {
  //Fetch button states from server
  fetch("/laundry/buttonstates")
    .then((response) => response.json())
    .then((data) => {
      for (const entry of data) {
        let row = document.querySelector(
          `table.today-laundry-bookings tr[data-order-id="${entry.id}"]`
        );
        if (!row) {
          //Reload page if booking is not known locally
          location.reload();
        }

        let washerActivation = false,
          dryerActivation = false,
          washerHint = false,
          dryerHint = false,
          cancel = false;

        if (entry.wash == "act") {
          washerActivation = true;
        } else if (entry.wash == "hint") {
          washerHint = true;
        }

        if (entry.dry == "act") {
          dryerActivation = true;
        } else if (entry.dry == "hint") {
          dryerHint = true;
        }

        if (entry.cancel) {
          cancel = true;
        }

        row
          .querySelector('[data-order-button="washer-activation"]')
          .classList.toggle("d-none", !washerActivation);
        row
          .querySelector('[data-order-button="washer-hint"]')
          .classList.toggle("d-none", !washerHint);
        row
          .querySelector('[data-order-button="dryer-activation"]')
          .classList.toggle("d-none", !dryerActivation);
        row
          .querySelector('[data-order-button="dryer-hint"]')
          .classList.toggle("d-none", !dryerHint);
        row
          .querySelector('[data-order-button="cancel"]')
          .classList.toggle("d-none", !cancel);
      }
    });
}

function armWallboxIndicators() {
  const containers = document.querySelectorAll(".wallbox-svg-container");
  const svgUrl = containers[0]?.dataset.svg;
  if (!svgUrl) return;

  const show = (svg, ...ids) =>
    ids.forEach((id) =>
      svg.querySelector(`#${id}`)?.style.setProperty("display", "block")
    );

  fetch(svgUrl)
    .then((r) => r.text())
    .then((svgText) => {
      const template = new DOMParser()
        .parseFromString(svgText, "image/svg+xml")
        .querySelector("svg");

      containers.forEach((container) => {
        const { available, device, href, label } = container.dataset;
        const isAvailable = available === "true";
        const svg = template.cloneNode(true);

        show(
          svg,
          ...(isAvailable
            ? ["baronline", "txtonline"]
            : ["baroffline", "txtoffline"]),
          `icon${device}`,
          `txt${device}`
        );

        if (!isAvailable && label) {
          svg
            .querySelector("#txtoffline")
            ?.setAttribute("transform", "translate(0,-40)");

          const text = document.createElementNS(
            "http://www.w3.org/2000/svg",
            "text"
          );
          text.setAttribute("x", "274");
          text.setAttribute("y", "495");
          text.setAttribute("text-anchor", "middle");
          Object.assign(text.style, {
            fontSize: "42px",
            fontFamily: "sans-serif",
            fill: "rgb(209,213,216)",
          });
          text.textContent = label;
          svg.appendChild(text);
        }

        const mount = href
          ? Object.assign(document.createElement("a"), { href })
          : null;
        (mount ?? container).appendChild(svg);
        if (mount) container.appendChild(mount);
      });
    });
}
